const PAYMENT_MESSAGE_FALLBACK = "Something went wrong. Please try again.";

export const sanitizeUserPaymentMessage = (
  message,
  fallback = PAYMENT_MESSAGE_FALLBACK,
) => {
  const text = String(message || "").trim();

  if (!text) {
    return fallback;
  }

  if (
    /sk_(test|live)_/i.test(text) ||
    /pk_(test|live)_/i.test(text) ||
    /whsec_/i.test(text) ||
    /api key/i.test(text) ||
    /secret key/i.test(text) ||
    /webhook secret/i.test(text)
  ) {
    return fallback;
  }

  return text;
};

export const getSafePaymentErrorMessage = (
  error,
  fallback = "Payment could not be started. Please try again.",
) =>
  sanitizeUserPaymentMessage(
    error?.response?.data?.userMessage ||
      error?.response?.data?.message ||
      error?.message,
    fallback,
  );
